import { EstimeDatesButtonProps } from "./types";
import { PencilIcon } from "@heroicons/react/20/solid";
import { FormattedMessage } from "react-intl";
import { dateToString } from "@feature/quotations/lib/utilities";
import { useEffect, useState } from "react";

export const EstimeDatesButton = ({
  setShowEstimeDates,
  selectedWorksite,
  isFreezed
}: EstimeDatesButtonProps) => {
  let [estimeDateWarning, setEstimeDateWarning] = useState(false);
  const freezed = isFreezed
  useEffect(() => {
    setEstimeDateWarning(false);
    let statusList = [];
    for (let el in selectedWorksite.cod_worksite_status) {
      let step = selectedWorksite.cod_worksite_status[el];
      if (step.flg_active) {
        statusList.push(step.step);
      }
    }
    // Oggi il mio cantiere non è ancora in esecuzione, ma secondo le date dovrebbe
    // esserlo (guardando la stima di inizio esecuzione);
    if (
      statusList.findIndex((el) => el === "open") === -1 &&
      new Date() >= new Date(selectedWorksite.estime_date_start)
    ) {
      setEstimeDateWarning(true);
    }
    // Oggi il mio cantiere non è ancora in fase di chiusura, ma secondo le date
    // dovrebbe esserlo (guardando la stima di fine esecuzione).
    if (
      statusList.findIndex((el) => el === "closed") === -1 &&
      new Date() >= new Date(selectedWorksite.estime_date_end)
    ) {
      setEstimeDateWarning(true);
    }
  }, [selectedWorksite]);

  return (
    <div className="flex">
      <span>
        <PencilIcon
          className="-ml-0.5 mr-1 h-4 w-4 mr-4"
          aria-hidden="true"
          cursor={freezed ? "not-allowed" : "pointer"}
          onClick={() => {
            if (freezed) return;
            setShowEstimeDates(true);
          }}
        />
      </span>
      <span
        className={
          estimeDateWarning
            ? "text-xs italic text-red-500 underline"
            : "text-xs italic"
        }
      >
        {selectedWorksite.estime_date_start &&
        selectedWorksite.estime_date_end ? (
          `${dateToString(selectedWorksite.estime_date_start)} - ${dateToString(
            selectedWorksite.estime_date_end
          )}`
        ) : (
          <FormattedMessage id="N/D" />
        )}
      </span>
    </div>
  );
};
